/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_PipelineInputs */

const cs_enum_entity_pipeline = /** @type {(inputs: Enum_Entity_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline`)
};

const en_enum_entity_pipeline = /** @type {(inputs: Enum_Entity_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline`)
};

/**
* | output |
* | --- |
* | "Pipeline" |
*
* @param {Enum_Entity_PipelineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_pipeline = /** @type {((inputs?: Enum_Entity_PipelineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_PipelineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_pipeline(inputs)
	return cs_enum_entity_pipeline(inputs)
});